document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('pb-ai-drawer');
  const backdrop = document.querySelector('.pb-ai-backdrop');
  document.querySelectorAll('[data-open-ai]').forEach(btn => btn.addEventListener('click', () => {
    drawer?.classList.add('open'); backdrop?.classList.add('open'); drawer?.setAttribute('aria-hidden','false');
  }));
  document.querySelectorAll('[data-close-ai]').forEach(btn => btn.addEventListener('click', () => {
    drawer?.classList.remove('open'); backdrop?.classList.remove('open'); drawer?.setAttribute('aria-hidden','true');
  }));
  document.querySelectorAll('.pb-quick button').forEach(btn => btn.addEventListener('click', () => {
    const input = document.getElementById('pb-ai-input');
    if (input) input.value = btn.textContent.trim();
  }));
  document.getElementById('pb-ai-send')?.addEventListener('click', () => {
    const send = document.getElementById('pb-ai-send');
    const input = document.getElementById('pb-ai-input');
    if (!input?.value?.trim()) return;
    send.textContent = 'Secure  backend ready to connect';
    setTimeout(() => send.textContent = 'Contact PB', 2200);
  });
});
